import axios from "axios";

const API_URL = "https://func-api-registration-dev.azurewebsites.net/api";
const accessToken = document.getElementById('accessToken')?.value;

const axiosApi = axios.create({
  baseURL: API_URL,
  headers: {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  },
  params: {},
});

axios.interceptors.request.use(function (config) {
  return config;
});

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, config) {
  return await axiosApi
    .get(url, {
      ...config,
      params: config,
    })
    .then((response) => response.data)
    .catch((error) => console.log(error));
}

export async function post(url, config) {
  return await axiosApi
    .post(url, {
      ...config,
    })
    .then((response) => response.data)
    .catch((error) => console.log(error));
}

export async function postRegis(url, config) {
  return await axiosApi
    .post(url, {
      ...config,
    })
    .then((response) => response)
    .catch((error) => console.log(error));
}
